/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Nav_HomeInputs */

const en_road_dude_nav_home = /** @type {(inputs: Road_Dude_Nav_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hotel Lobby home`)
};

const zh_road_dude_nav_home = /** @type {(inputs: Road_Dude_Nav_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回 Hotel Lobby 首页`)
};

/**
* | output |
* | --- |
* | "Hotel Lobby home" |
*
* @param {Road_Dude_Nav_HomeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_nav_home = /** @type {((inputs?: Road_Dude_Nav_HomeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Nav_HomeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_nav_home(inputs)
	return zh_road_dude_nav_home(inputs)
});
export { road_dude_nav_home as "road_dude.nav.home" }